import { LineItem } from "gpc-shared-types";

export type ProductLineProps = LineItem & { currencyCode?: string };

const ProductLine: React.FC<ProductLineProps> = ({
  title,
  currentQuantity,
  image,
  discountedTotalSet,
  currencyCode,
}: ProductLineProps) => {
  const totalPrice = parseFloat(
    discountedTotalSet?.presentmentMoney?.amount ?? "0",
  ).toFixed(2);

  return (
    <>
      <div className="gpc__product-line gpc__product-line__mobile">
        <div className="gpc__product-line__image">
          {image && image.url ? (
            <img src={`${image.url}`} />
          ) : (
            <img src="/placeholder.png" />
          )}
        </div>
        <div className="gpc__product-line__description">
          <div className="gpc__product-line__name">
            <p>{title}</p>
          </div>
          <div className="gpc__product-line__quantity_and_price">
            <div className="gpc__product-line__quantity">
              <p>Qty: {currentQuantity}</p>
            </div>
            <div className="gpc__product-line__price">
              <p>
                {currencyCode} {totalPrice}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="gpc__product-line">
        <div className="gpc__product-line__image">
          {image && image.url ? (
            <img src={`${image.url}`} />
          ) : (
            <img src="/placeholder.png" />
          )}
        </div>
        <div className="gpc__product-line__name">
          <p>
            {currentQuantity}x {title}
          </p>
        </div>
        <div className="gpc__product-line__price">
          <p>
            {currencyCode} {totalPrice}
          </p>
        </div>
      </div>
    </>
  );
};

export default ProductLine;
